import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Style from "../Style/CourseMore.module.scss";
import { Helmet, HelmetProvider } from "react-helmet-async";

const baseURL = process.env.REACT_APP_BASE_URL;

const CourseMore = ({ darkMode }) => {
  const { skill_detail_id } = useParams();
  const [courseMoreData, setCourseMoreData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!skill_detail_id) return;

    axios
      .get(`${baseURL}/api/course_detail/skill/${skill_detail_id}`)
      .then((res) => {
        setCourseMoreData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching course more details", err);
        setLoading(false);
      });
  }, [skill_detail_id]);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Course Details</title>
      </Helmet>
      <div className={`${Style.CourseMore} ${darkMode ? Style.dark : ""}`}>
        <div className={Style.wrapper}>
          {loading ? (
            <p>Loading...</p>
          ) : courseMoreData.length === 0 ? (
            <p>No details found for this course.</p>
          ) : (
            courseMoreData.map((item) => (
              <div key={item.id} className={Style.detailCard}>
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
              </div>
            ))
          )}
        </div>
      </div>
    </HelmetProvider>
  );
};

export default CourseMore;
